module.exports = __webpack_public_path__ + "img/07.14a37e14.jpg";